export default function () {
    const config = useRuntimeConfig().public;

    function buildVideo(lesson, course) {
        if (!lesson) return undefined;

        const breadcrumbList = {
            '@type': 'BreadcrumbList',
            'itemListElement': [
                {
                    '@type': 'ListItem',
                    'position': 1,
                    'item': {
                        'name': 'Home',
                        '@id': config.base,
                    }
                }
            ]
        };

        if (course) {
            breadcrumbList.itemListElement.push({
                '@type': 'ListItem',
                'position': 2,
                'item': {
                    'name': 'Courses',
                    '@id': `${config.base}/courses`,
                }
            });

            breadcrumbList.itemListElement.push({
                '@type': 'ListItem',
                'position': 3,
                'item': {
                    'name': course.course_title,
                    '@id': `${config.base}/courses/${course.course_slug}`
                }
            });

            breadcrumbList.itemListElement.push({
                '@type': 'ListItem',
                'position': 4,
                'item': {
                    'name': lesson.lesson_title,
                    '@id': `${config.base}/videos/${lesson.lesson_slug}`
                },
            });
        } else {
            breadcrumbList.itemListElement.push({
                '@type': 'ListItem',
                'position': 2,
                'item': {
                    'name': lesson.lesson_category || 'Lessons',
                    '@id': `${config.base}/videos`
                },
            });

            breadcrumbList.itemListElement.push({
                '@type': 'ListItem',
                'position': 3,
                'item': {
                    'name': lesson.lesson_title,
                    '@id': `${config.base}/videos/${lesson.lesson_slug}`,
                },
            });
        }

        return breadcrumbList;
    }

    function buildCourse(course) {
        if (!course) return undefined;

        return {
            '@type': 'BreadcrumbList',
            'itemListElement': [
                {
                    '@type': 'ListItem',
                    'position': 1,
                    'name': 'Home',
                    'item': 'https://www.andyguitar.co.uk'
                },
                {
                    '@type': 'ListItem',
                    'position': 2,
                    'name': 'Courses',
                    'item': 'https://www.andyguitar.co.uk/courses'
                },
                {
                    '@type': 'ListItem',
                    'position': 3,
                    'name': course.course_title,
                    'item': `https://www.andyguitar.co.uk/courses/${course.course_slug}`
                }
            ]
        };
    }

    return { buildVideo, buildCourse };
}
